import { render, staticRenderFns } from "./TagEditDialog.vue?vue&type=template&id=97e01850&lang=pug"
import script from "./TagEditDialog.vue?vue&type=script&lang=js"
export * from "./TagEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports